const mod = require('react-i18next')

module.exports = mod
